module.exports = __webpack_public_path__ + "static/media/tagujam_logo.26ac5c89.svg";